export default "__VITE_ASSET__B6D0ZHdz__"